//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/ASCImporter.js";
import "../no/AcisExporter.js";
import "../no/AcisImporter.js";
import "../no/Catiav4Creator.js";
import "../no/Catiav4Importer.js";
import "../no/Catiav5Creator.js";
import "../no/Catiav5Importer.js";
import "../no/CreoImporter.js";
import "../no/DxfdwgCreator.js";
import "../no/DxfdwgImporter.js";
import "../no/ExtendedRealityFileCreator.js";
import "../no/G3DImporter.js";
import "../no/GeospatialDataImporter.js";
import "../no/IfcCreator.js";
import "../no/IfcImporter.js";
import "../no/IgesCreator.js";
import "../no/IgesImporter.js";
import "../no/InventorImporter.js";
import "../no/NXTo2dCreator.js";
import "../no/ParasolidExporter.js";
import "../no/ParasolidImporter.js";
import "../no/QuickUsdzCreator.js";
import "../no/RevitImporter.js";
import "../no/RhinoImporter.js";
import "../no/STLCreator.js";
import "../no/Step203Importer.js";
import "../no/Step214Importer.js";
import "../no/Step242Importer.js";
import "../no/StepCreator.js";
import "../no/ThreeDXMLImporter.js";
import "../no/Validator.js";
import "../no/VirtuallabImporter.js";
import "../no/WavefrontObjCreator.js";
import "../no/WavefrontObjImporter.js";
import "../no/Session.js";
let d=[[],[[[],"CreateCatiav4Importer",{R_:{builder:"Catiav4Importer"}},0,0],[[],"CreateStep214Importer",{R_:{builder:"Step214Importer"}},0,0],[[],"CreateStep242Importer",{R_:{builder:"Step242Importer"}},0,0],[[],"CreateCatiav5Importer",{R_:{builder:"Catiav5Importer"}},0,0],[[],"CreateIgesImporter",{R_:{builder:"IgesImporter"}},0,0],[[],"CreateStep203Importer",{R_:{builder:"Step203Importer"}},0,0],[[],"CreateDxfdwgImporter",{R_:{builder:"DxfdwgImporter"}},0,0],[[],"CreateIgesCreator",{R_:{builder:"IgesCreator"}},0,0],[[],"CreateStepCreator",{R_:{builder:"StepCreator"}},0,0],[[],"CreateCatiav4Creator",{R_:{builder:"Catiav4Creator"}},0,0],[[],"CreateCatiav5Creator",{R_:{builder:"Catiav5Creator"}},0,0],[[],"CreateDxfdwgCreator",{R_:{builder:"DxfdwgCreator"}},0,0],[[],"CreateNxto2dCreator",{R_:{builder:"NXTo2dCreator"}},0,0],[[],"CreateCreoImporter",{R_:{builder:"CreoImporter"}},0,0],[[],"CreateAscImporter",{R_:{builder:"ASCImporter"}},0,0],[[],"CreateAcisImporter",{R_:{builder:"AcisImporter"}},0,0],[[],"CreateAcisExporter",{R_:{builder:"AcisExporter"}},0,0],[[],"CreateStlCreator",{R_:{builder:"STLCreator"}},0,0],[[],"CreateVirtuallabImporter",{R_:{builder:"VirtuallabImporter"}},0,0],[[],"CreateWavefrontObjImporter",{R_:{builder:"WavefrontObjImporter"}},0,0],[[],"CreateWavefrontObjCreator",{R_:{builder:"WavefrontObjCreator"}},0,0],[[],"CreateIfcImporter",{R_:{builder:"IfcImporter"}},0,0],[[],"CreateIfcCreator",{R_:{builder:"IfcCreator"}},0,0],[[],"CreateRevitImporter",{R_:{builder:"RevitImporter"}},0,0],[[],"CreateParasolidImporter",{R_:{builder:"ParasolidImporter"}},0,0],[[],"CreateParasolidExporter",{R_:{builder:"ParasolidExporter"}},0,0],[[],"CreateValidator",{R_:{builder:"Validator"}},0,0],[[],"CreateGeospatialDataImporter",{R_:{builder:"GeospatialDataImporter"}},0,0],[[],"CreateG3dImporter",{R_:{builder:"G3DImporter"}},0,0],[[],"CreateRhinoImporter",{R_:{builder:"RhinoImporter"}},0,0],[[],"CreateThreedxmlImporter",{R_:{builder:"ThreeDXMLImporter"}},0,0],[[],"CreateInventorImporter",{R_:{builder:"InventorImporter"}},0,0]],[]];
SPLM.DexManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.DexManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;